if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.targetId = this.dataset.targetId;
        this.target = document.getElementById(this.targetId);
        this.button = this.querySelector('.sticky-atc__button');

        if (this.button) {
          this.button.addEventListener('click', () => this.proxyClick());
        }

        if (this.target && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              // Show the sticky bar once the real button is scrolled out of view,
              // but only once the page has scrolled down into the product info at all.
              this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
            },
            { threshold: 0 }
          );
          this.observer.observe(this.target);
        }

        // Keep price/availability in sync when the shopper changes variants.
        document.addEventListener('variant:change', (event) => this.handleVariantChange(event));
      }

      handleVariantChange(event) {
        const variant = event.detail && event.detail.variant;
        if (!variant) return;

        const priceEl = this.querySelector('.sticky-atc__price');
        if (priceEl && variant.price != null) {
          priceEl.textContent = Shopify.formatMoney
            ? Shopify.formatMoney(variant.price)
            : priceEl.textContent;
        }

        if (this.button) {
          this.button.disabled = !variant.available;
        }
      }

      proxyClick() {
        if (this.target) this.target.click();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
